import { render, staticRenderFns } from "./bar-app-mobile.vue?vue&type=template&id=cb166678&"
import script from "./bar-app-mobile.vue?vue&type=script&lang=js&"
export * from "./bar-app-mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports